import React, { useEffect } from "react";
import "./Employee.css";
import { useLocation, useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getEmployee } from "../../actions/userActions/employeeAction";
import { useSelector } from "react-redux";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";import HrComponent from "../reuse_components/HrComponent";
import { t } from "../../locales/translate";

const Profile = (props) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  const user = JSON.parse(localStorage.getItem("user"));
  const userId = user?.result[0]?.user?.id;
  useEffect(() => {
    dispatch(getEmployee(userId));
  }, []);

  const employeeData = useSelector((state) => state.employees_reducer.employee);
  return (
  <>
      <div>

    <LoadingOverlay isVisible={employeeData === "isLoading"} />
    <div className="profile-wrapper">
      {employeeData !== "isLoading" && employeeData != undefined && employeeData.length !== 0 && (
        <>
        <div className="row">
              <div className="col-md-2 avatar-column">
                <div className="employee-profile-center">
                  <div className="avatar-dp-set">
                    <p>
                      {employeeData.firstName.charAt(0)}
                      {employeeData.lastName.charAt(0)}
                    </p>
                  </div>
                  <div className="person_name">
                    {employeeData.firstName} {employeeData.lastName}
                  </div>
                  <div className="designation_data">
                    {employeeData.designationName}
                  </div>
                </div>
              </div>


              <div className="col-md-2">
                <div className="set_text_gap">
                  <p className="details_text">{t("firstName")}</p>
                  <p className="details_text">{t("lastName")}</p>
                  <p className="details_text">{t("gender")}</p>
                  <p className="details_text">{t("personalEmail")}</p>
                  <p className="details_text">{t("address")}</p>
                </div>
              </div>

              <div className="col-md-3">
                <div className="set_text_gap">
                  <p className="label_data">{employeeData.firstName}</p>
                  <p className="label_data">{employeeData.lastName}</p>
                  <p className="label_data">{employeeData.genderName}</p>
                  <p className="label_data">{employeeData.personalEmail}</p>
                  <p className="label_data">{employeeData.address}</p>
                </div>
              </div>

              <div className="col-md-2">
                <div className="set_text_gap">
                  <p className="details_text">{`${t("personalContact")} 1`}</p>
                  <p className="details_text">{`${t("personalContact")} 2`}</p>
                  <p className="details_text">{t("passportNo")}</p>
                  <p className="details_text">{t("city")}</p>
                  <p className="details_text">{t("employeeId")}</p>
                </div>
              </div>

              <div className="col-md-2">
                <div className="set_text_gap">
                  <p className="label_data">{employeeData.personalContact1}</p>
                  <p className="label_data">
                    {employeeData.personalContact2 ? (
                      employeeData.personalContact2
                    ) : (
                      <span className="not-available-text">Not available</span>
                    )}
                  </p>
                  <p className="label_data">
                    {employeeData.passport ? (
                      employeeData.passport
                    ) : (
                      <span className="not-available-text">Not available</span>
                    )}
                  </p>
                  <p className="label_data">{employeeData.cityName}</p>
                  <p className="label_data">
                    {employeeData.empId ? (
                      employeeData.empId
                    ) : (
                      <span className="not-available-text">Not available</span>
                    )}
                  </p>
                </div>
              </div>
              <div className="col-md-1"></div>
            </div>

            <HrComponent />

            <div className="row">
              <div className="col-md-2">
                <div className="set_text_gap">
                  <p className="details_text">{t("department")}</p>
                  <p className="details_text">{t("designation")}</p>
                  <p className="details_text">{t("role")}</p>
                  <p className="details_text">{t("team")}</p>
                  <p className="details_text">{t("reportsTo")}</p>
                </div>
              </div>

              <div className="col-md-4">
                <div className="set_text_gap">
                  <p className="label_data">{employeeData.departmentName}</p>
                  <p className="label_data">{employeeData.designationName}</p>
                  {employeeData.employeeRoles && employeeData.employeeRoles.map((role, index) => (
                    <p className="label_data" key={index}>{role.roleName}</p>
                  ))}
                  <p className="label_data">{employeeData.teamName}</p>
                  <p className="label_data">
                    {employeeData.reportsToName ? (
                      employeeData.reportsToName
                    ) : (
                      <span className="not-available-text">Not available</span>
                    )}
                  </p>
                </div>
              </div>

              <div className="col-md-2">
                <div className="set_text_gap">
                  <p className="details_text">{t("employmentStatus")}</p>
                  <p className="details_text">{t("officialEmail")}</p>
                  <p className="details_text">{t("officialContact")} 1</p>
                  <p className="details_text">{t("officialContact")} 2</p>
                </div>
              </div>

              <div className="col-md-4">
                <div className="set_text_gap">
                  <p className="label_data">{employeeData.employmentStatusName}</p>
                  <p className="label_data">{employeeData.officialEmail}</p>
                  <p className="label_data">{employeeData.officialContact1}</p>
                  <p className="label_data">
                    {employeeData.officialContact2 ? (
                      employeeData.officialContact2
                    ) : (
                      <span className="not-available-text">Not available</span>
                    )}
                  </p>
                </div>
              </div>
            </div>

            <div className="row mt-5">
              <div className="col-md-2">
                <p className="details_text">{t("jobLocation")}</p>
              </div>
              <div className="col-md-10">
                <p className="label_data">
                  {employeeData.jobLocationName ? (
                    employeeData.jobLocationName
                  ) : (
                    <span className="not-available-text">Not available</span>
                  )}
                </p>
              </div>
            </div>
          </>
        )}
      </div>
    </div>

    </>
  );
};

export default Profile;